// dd.mm.yyyy -> yyyy-mm-dd
// need to do it because of datepicker behaviour
export function switchDateFormats(value: unknown): string {
  if (!value) { return ''; }
  const valueAsString = value as string;
  return valueAsString.split('.').reverse().join('-');
}
